export default __webpack_public_path__ + "3b4a3bbd657a0803c41224934ab60bda.jpg";